// oxlint-disable-next-line no-restricted-imports
import { fromJS, List, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

import type { Experiment } from '#utils/flags/records/Experiment';
import { createExperiment, createExperimentItem } from '#utils/flags/records/Experiment';

type ExperimentInfoProps = { baselineIdx: number; items: List<Experiment> };

export class ExperimentInfo extends Record<ExperimentInfoProps>({
  baselineIdx: 0,
  items: List(),
}) {
  toRep() {
    return fromJS(this.toJSON()).withMutations((map: ExperimentInfo) => {
      map.update('items', (its) => its.map((it) => it.toRep()));
    });
  }
}

function getMetricItems(items: List<Experiment>) {
  // metrics from the get all flags endpoint only contain metric ids and not keys
  const createExperimentItemsByKey = items?.filter((metric) => !!metric.metricKey).map(createExperimentItem);
  if (items) {
    if (!createExperimentItemsByKey.isEmpty()) {
      return createExperimentItemsByKey;
    } else {
      return items?.filter((metric) => metric.getIn(['_metric', '_id'])).map(createExperimentItem);
    }
  }
  return List<Experiment>();
}

export function createExperimentInfo(props?: CreateFunctionInput<ExperimentInfo>) {
  return new ExperimentInfo(fromJS(props)).update('items', (items) => getMetricItems(items.map(createExperiment)));
}
